import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import HWL from '../Assets/images/hwl3.png';
import HWL2 from '../Assets/images/Vector.png';
import HWL5 from '../Assets/images/hwl5.png';
import correct from "../Assets/images/Frame 34.png"
import img1 from "../Assets/images/Layer_1.png"
import img2 from "../Assets/images/Layer_1 (1).png"
import LearningProcess from '../Components/learningProcess/LearningProcess';
import img3 from "../Assets/images/Frame 1000.png"
import img4 from "../Assets/images/frame 1001.png"
import img5 from "../Assets/images/frame 1002.jpg"
import { Link, useNavigate } from 'react-router-dom';
import img6 from "../Assets/images/Vector5.png"
import { Modal } from 'antd';
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup';


const HowWeLearn = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const data = [
        { description: t("data_live_virtual_classrooms") },
        { description: t("data_interactive_multimedia") },
        { description: t("data_real_time_feedback") },
        { description: t("data_peer_interaction") },
        { description: t("data_flexible_scheduling") }
    ];

    const data2 = [
        { header: t("data2_speaking_assessment_header"), description: t("data2_speaking_assessment_desc") },
        { header: t("data2_listening_comprehension_header"), description: t("data2_listening_comprehension_desc") },
        { header: t("data2_reading_skills_header"), description: t("data2_reading_skills_desc") },
        { header: t("data2_writing_evaluation_header"), description: t("data2_writing_evaluation_desc") }
    ];

    const data3 = [
        { header: t("data3_goal_setting_header"), description: t("data3_goal_setting_desc") },
        { header: t("data3_timeline_planning_header"), description: t("data3_timeline_planning_desc") },
        { header: t("data3_resource_allocation_header"), description: t("data3_resource_allocation_desc") },
        { header: t("data3_support_structure_header"), description: t("data3_support_structure_desc") }
    ];

    const features = [
        { title: t("features_native_proficiency") },
        { title: t("features_advanced_degrees") },
        { title: t("features_diverse_experience") },
        { title: t("features_professional_development") }
    ];

    const features2 = [
        { title: t("features2_study_groups") },
        { title: t("features2_cultural_exchange") },
        { title: t("features2_peer_mentoring") },
        { title: t("features2_online_forums") }
    ];

    const features3 = [
        { title: t("features3_platform_guidance") },
        { title: t("features3_technical_troubleshooting") },
        { title: t("features3_device_support") },
        { title: t("features3_resource_access") }
    ];

    return (
        <div className='how-we-learn'>
            <section className='first-section '>
                <h2 className='mb-3'>{t("how_you_learn?")}</h2>
                <p className='mb-4'>
                    {t("how_you_learn_desc")}
                </p>
            </section>

            <Row className='justify-content-start flex-column '>
                <Col md={12} className='green-div'>
                    <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                        <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>{t("start_now")}</button>
                    </div>
                </Col>
            </Row>

            <section className='my-5 k12-grade'>
                <Container>
                    <h2 className='text-center '>{t("flexible_paths_title")}</h2>
                    <p className='text-center'>{t("flexible_paths_desc")}</p>
                </Container>
            </section>

            <section className='w-100 d-flex justify-content-center align-items-center self-learning-container'>
                <div className='online-learning my-5'>
                    <div>
                        <h2 className='mb-3'>{t("online_learning2")}</h2>
                        <div className='gold-line'></div>
                        <p className='mb-4 '>{t("online_learning_desc2")}</p>
                    </div>
                    <img src={HWL} />
                </div>
            </section>

            <section className='w-100 d-flex justify-content-center align-items-center self-learning-container'>
                <div className='Self-Learning my-5'>
                    <img src={HWL2} className='firstIcon' />
                    <div className='d-flex justify-content-center flex-column  '>
                        <h2 className='mb-3'>{t("self_learning2")}</h2>
                        <div className='gold-line'></div>
                        <p className='mb-4 digital-learning'>{t("self_learning_desc2")}</p>
                    </div>
                    <div className='whatYouWillGet'>
                        <h2 className='mb-3'>{t("what_you_get")}</h2>
                        {data.map((item, index) => (
                            <div key={index} className=" d-flex align-items-start gap-1">
                                <img src={correct} alt="checkIcon" className="me-3 mt-1 checkIcon" width={"22px"} height={"22px"} />
                                <p
                                    dangerouslySetInnerHTML={{ __html: item?.description }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='w-100 d-flex justify-content-center align-items-center self-learning-container'>
                <div className='online-learning my-5 gap-2'>
                    <div>
                        <h2 className='mb-3'>{t("blended_learning2")}</h2>
                        <div className='gold-line'></div>
                        <p className='mb-4'>{t("blended_learning_desc2")}</p>
                    </div>
                    <img src={HWL5} />
                </div>
            </section>

            <section className='placement-personaliztion'>
                <div className='third-section my-5 '>
                    <div className='why-kalemon my-5 py-5 d-flex flex-column gap-3 justigy-content-center align-items-center'>
                        <h2> {t("placement_personalization")} </h2>
                        <p> {t("placement_personalization_desc")} </p>
                    </div>
                </div>

                <Row className='justify-content-center flex-wrap gap-3'>
                    <Col md={6} className='freeAssessment'>
                        <div className='freePlacement'>
                            <div>
                                <h2> {t("free_placement_assessment")} </h2>
                                <p> {t("free_placement_assessment_desc")} </p>

                            </div>
                            <div className='mt-4'>  <img src={img1} /></div>
                        </div>
                        <div className='freePlacementList'>
                            {data2.map((item, index) => (
                                <div key={index} className=" d-flex align-items-start gap-1">
                                    <img src={correct} alt="checkIcon" className="me-3 mt-1 checkIcon" />
                                    <p className='p-header'>{item?.header} : <span className='p-description'>{item?.description}</span></p>
                                </div>
                            ))
                            }
                            <div className="ph-btns  last-sec">
                                <button className="btn btn-ph-Apply" onClick={() => navigate("/contact-us")}>{t("take_free_assessment")}</button>

                            </div>
                        </div>
                    </Col>


                    <Col md={6} className='freeAssessment'>
                        <div className='freePlacement'>
                            <div>
                                <h2> {t("personalized_learning_plan")} </h2>
                                <p> {t("personalized_learning_plan_desc")} </p>

                            </div>
                            <img src={img2} />
                        </div>
                        <div className='freePlacementList'>
                            {data3.map((item, index) => (
                                <div key={index} className=" d-flex align-items-start gap-1">
                                    <img src={correct} alt="checkIcon" className="me-3 mt-1 checkIcon" />

                                    <p className='p-header'>{item?.header} : <span className='p-description'>{item?.description}</span></p>
                                </div>
                            ))
                            }
                            <div className="ph-btns last-sec">

                                <button className="btn btn-ph-Questions ms-3" onClick={() => setIsModalOpen(true)}>{t("start_now")} </button>

                            </div>
                        </div>
                    </Col>

                </Row>

            </section>
            <section>
                <LearningProcess />
            </section>

            <section className="support">
                <div className="support__inner">
                    <h2 className="support__heading">{t("comprehensive_support")}</h2>

                    <div className="support__grid">
                        <figure className="card">
                            <img
                                src={img3}
                                className="card__img"
                            />
                            <figcaption className="card__overlay">
                                <h3 className="card__title">{t("expert_instructors")}</h3>
                                <p className="card__text">
                                    {t("expert_instructors_desc")}
                                </p>
                            </figcaption>
                        </figure>

                        <ul className="list">
                            {features.map((f, i) => (
                                <li className="list__item" key={i}>
                                    <img src={correct} alt="checkIcon" className="me-3 mt-1 checkIcon" />
                                    <span>{f.title}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

            <section className="support ">
                <div className="support__inner">

                    <div className="support__grid left-support">

                        <ul className="list">
                            {features2.map((f, i) => (
                                <li className="list__item" key={i}>
                                    <img src={correct} alt="checkIcon" className="me-3 mt-1 checkIcon" />
                                    <span>{f.title}</span>
                                </li>
                            ))}
                        </ul>

                        <figure className="card">
                            <img
                                src={img4}
                                className="card__img"
                            />
                            <figcaption className="card__overlay">
                                <h3 className="card__title">{t("learning_community")}</h3>
                                <p className="card__text">
                                    {t("learning_community_desc")}
                                </p>
                            </figcaption>
                        </figure>
                    </div>
                </div>
            </section>


            <section className="support">
                <div className="support__inner">

                    <div className="support__grid">
                        <figure className="card">
                            <img
                                src={img5}
                                className="card__img"
                            />
                            <figcaption className="card__overlay">
                                <h3 className="card__title">{t("technical_support")}</h3>
                                <p className="card__text">
                                    {t("technical_support_desc")}
                                </p>
                            </figcaption>
                        </figure>

                        <ul className="list">
                            {features3.map((f, i) => (
                                <li className="list__item" key={i}>
                                    <img src={correct} alt="checkIcon" className="me-3 mt-1 checkIcon" />
                                    <span>{f.title}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>
            <section className='fifth-section mt-5'>
                <Container>
                    <h4>{t('success_stories')}</h4>
                    <img src={img6} alt='' className='w-100' />
                    <Link to={""} className='join-community my-2 w-100' onClick={()=>setIsModalOpen(true)}>{t('join_community')}</Link>
                    <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0"
                                className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                                aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner">

                            <div className="carousel-item active">
                                <div className="row my-3 pb-5 gx-5 mx-5">
                                    <div className="col-lg-6">
                                        <div className="card h-100">
                                            <p>{t("testimonial_1_text")}</p>
                                            <h5 className='mt-3'>{t("testimonial_1_author")}</h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="card h-100">
                                            <p>{t("testimonial_2_text")}</p>
                                            <h5 className='mt-3'>{t("testimonial_2_author")}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="carousel-item">
                                <div className="row my-3 pb-5 gx-5 mx-5">
                                    <div className="col-lg-6">
                                        <div className="card h-100">
                                            <p>{t('testimonials.testimonial1.text')}</p>
                                            <h5 className='mt-3'>{t('testimonials.testimonial1.name')}</h5>
                                            <h6>{t('testimonials.testimonial1.title')}</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="card h-100">
                                            <p>{t('testimonials.testimonial2.text')}</p>
                                            <h5 className='mt-3'>{t('testimonials.testimonial2.name')}</h5>
                                            <h6>{t('testimonials.testimonial2.title')}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>


                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">{t('testimonials.prev')}</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">{t('testimonials.next')}</span>
                        </button>
                    </div>
                </Container>
                <div className='fifth-section-footer mt-5'>
                    <h3>{t('start_learning_your_way')}</h3>
                    <p>{t('start_learning_your_way_desc')}</p>
                    <div className='fifth-section-footer-btns '>
                        <button className='btn takeplacement' onClick={() => setIsModalOpen(true)}>{t('take_free_assessment')}</button>
                        <button className='btn explore' onClick={() => navigate("/all-programs")}>{t('explore_all_programs')}</button>
                    </div>
                </div>
            </section>
            <Modal
                open={isModalOpen}
                footer={null}
                destroyOnClose
                onCancel={() => setIsModalOpen(false)}
                width={"80vw"} // close handler
            >
                <RegistrationPopup setIsModalOpen={setIsModalOpen} />
            </Modal>
        </div>
    )
}

export default HowWeLearn
